import { Route, Routes, ScrollRestoration } from "react-router-dom";
import SelectFundMethod from "./fund/SelectFundMethod";
import FundWithCard from "./fund/FundWithCard";
import VirtualAccount from "./fund/VirtualAccount";

const Fund = () => {
  return (
    <>
      <ScrollRestoration />
      <Routes>
        <Route path="/" element={<SelectFundMethod />} />
        <Route path="/fund-with-card" element={<FundWithCard />} />
        <Route path="/virtual-account-details" element={<VirtualAccount />} />
      </Routes>
    </>
  );
};

export default Fund;
